enum BenefitId {
  Equity = 'equity',
  Pto = 'pto',
  Medical = 'medical',
  ParentalLeave = 'parental-leave',
  Remote = 'remote',
  Retirement = 'retirement',
  Edu = 'edu',
  Donation = 'donation-matching'
}

type Benefit = {
  id: BenefitId;
  title: string;
  desc: string;
  iconSrc: string;
};

// Careers page does not need translations
const BENEFITS: Benefit[] = [
  {
    id: BenefitId.Equity,
    title: 'Competitive pay + equity',
    desc: 'At AllTrails, you won’t be sacrificing take-home pay for equity. We offer competitive salaries, along with stock options that have real-world value.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-equity.svg')
  },
  {
    id: BenefitId.Pto,
    title: 'Unlimited time off + monthly trail day',
    desc: 'As nature lovers, we value our time away from keyboards. That’s why we all hit the trail once a month — and take as much “me” time as we need.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-pto.svg')
  },
  {
    id: BenefitId.Medical,
    title: 'Free medical coverage',
    desc: 'You read that right. We don’t just offer excellent medical, dental, and vision insurance. We also pay 100% medical premiums for you and your family.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-medical.svg')
  },
  {
    id: BenefitId.ParentalLeave,
    title: '16-week parental leave',
    desc: 'When it’s time to focus on the little one, we’ve got you covered. Whether you’re giving birth or adopting, we’re here to support you in your new parent journey.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-parental-leave.svg')
  },
  {
    id: BenefitId.Remote,
    title: 'Remote-first culture',
    desc: 'Our team is distributed by design, not necessity. We provide a home workspace stipend, get-together budgets, and lots of ways to connect virtually for work and fun.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-remote.svg')
  },
  {
    id: BenefitId.Retirement,
    title: '401(k) + match',
    desc: 'The future is bright — and we’re here to help you build that nest egg. We’ll match your contributions dollar-for-dollar up to 4%.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-retirement.svg')
  },
  {
    id: BenefitId.Edu,
    title: 'Wellness, wifi, and education stipends',
    desc: 'We believe in investing in our people. That’s why we give an annual learning & development budget, plus monthly reimbursements for wellness and wifi.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-edu.svg')
  },
  {
    id: BenefitId.Donation,
    title: '100% donation matching',
    desc: 'Passionate about a cause? We’re with you. AllTrails will match every dollar of your one-time or recurring donations to thousands of nonprofit organizations.',
    iconSrc: require('../../../../assets/images/icons/careers/benefits-donation-matching.svg')
  }
];

export type { Benefit };
export { BENEFITS, BenefitId };
